module.exports = __webpack_public_path__ + "static/media/pg_testing_b_bg.2b58e1e2.jpg";